<template>
  <div class="my-5 p-5">
    <div class="row b1 h3 mb-10 gray-text">
      {{ $t("panelUser.history") }}
    </div>
    <template>
      <div class="row">
        <div class="col-1 redCirc"></div>
        <div class="col-11 h4 b1 mt-n3 mb-5">
          {{ $t("waitToPay") }}
        </div>
      </div>

      <v-simple-table class="mb-10 bcg-none border">
        <template v-slot:default>
          <thead>
            <tr>
              <td class="text-center b1">{{ $t("cartDate") }}</td>
              <td class="text-center b1">{{ $t("trickingCode") }}</td>
              <td class="text-center b1">{{ $t("expence") }}</td>
              <td class="text-center b1">{{ $t("orderStatus") }}</td>
              <td class="text-center b1"></td>
              <td class="text-center b1"></td>
              <td class="b1"></td>
            </tr>
          </thead>
          <tbody v-for="item in cartData" :key="item.row">
            <tr v-if="item.payment_status == 'PrePay'">
              <td class="text-center">{{ item.persian_date }}</td>
              <td class="text-center">{{ item.tracking_code }}</td>
              <td class="text-center">{{ item.persian_sum }}</td>
              <td class="text-center redColor">{{ $t("waitToPay") }}</td>
              <td class="text-center b1"></td>
              <td class="text-center b1"></td>
              <td class="text-center b1"></td>
              <td class="text-center b1 p-2">
                <div
                  :id="item.id"
                  @click="detailes(item.id)"
                  class="chips rounded-pill btn"
                >
                  {{ $t("details") }}
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <template>
      <div class="row">
        <div class="col-1 yellowCirc"></div>
        <div class="col-11 h4 b1 mt-n3 mb-5">
          {{ $t("gettingReady") }}
        </div>
      </div>

      <v-simple-table class="mb-10 bcg-none border">
        <template v-slot:default>
          <thead>
            <tr>
              <td class="text-center b1">{{ $t("date") }}</td>
              <td class="text-center b1">{{ $t("trickingCode") }}</td>
              <td class="text-center b1">{{ $t("expence") }}</td>
              <td class="text-center b1">{{ $t("orderStatus") }}</td>
              <td class="text-center b1"></td>
              <td class="text-center b1"></td>
              <td class="b1"></td>
            </tr>
          </thead>
          <tbody v-for="item in cartData" :key="item.row">
            <tr v-if="item.payment_status == 'PayDone'">
              <td class="text-center">{{ item.persian_date }}</td>
              <td class="text-center">{{ item.tracking_code }}</td>
              <td class="text-center">{{ item.persian_sum }}</td>
              <td class="text-center yellowColor">{{ $t("gettingReady") }}</td>
              <td class="text-center b1"></td>
              <td class="text-center b1"></td>
              <td class="text-center b1 p-2">
                <div
                  :id="item.id"
                  @click="detailes(item.id)"
                  class="chips rounded-pill btn"
                >
                  {{ $t("details") }}
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <template>
      <div class="row">
        <div class="col-1 orangeCirc"></div>
        <div class="col-11 h4 b1 mt-n3 mb-5">
          {{ $t("waitToDeliver") }}
        </div>
      </div>

      <v-simple-table class="mb-10 bcg-none border">
        <template v-slot:default>
          <thead>
            <tr>
              <td class="text-center b1">{{ $t("date") }}</td>
              <td class="text-center b1">{{ $t("trickingCode") }}</td>
              <td class="text-center b1">{{ $t("expence") }}</td>
              <td class="text-center b1">{{ $t("orderStatus") }}</td>
              <td class="text-center b1"></td>
              <td class="text-center b1"></td>
              <td class="b1"></td>
            </tr>
          </thead>
          <tbody v-for="item in cartData" :key="item.row">
            <tr v-if="item.payment_status == 'Transfer'">
              <td class="text-center">{{ item.persian_date }}</td>
              <td class="text-center">{{ item.tracking_code }}</td>
              <td class="text-center">{{ item.persian_sum }}</td>
              <td class="text-center orangeColor">{{ $t("waitToDeliver") }}</td>
              <td class="text-center b1"></td>
              <td class="text-center b1"></td>
              <td class="text-center b1 p-2">
                <div
                  :id="item.id"
                  @click="detailes(item.id)"
                  class="chips rounded-pill btn"
                >
                  {{ $t("details") }}
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <template>
      <div class="row">
        <div class="col-1 greenCirc"></div>
        <div class="col-11 h4 b1 mt-n3 mb-5">
          {{ $t("delivered") }}
        </div>
      </div>

      <v-simple-table class="mb-10 bcg-none border">
        <template v-slot:default>
          <thead>
            <tr>
              <td class="text-center b1">{{ $t("date") }}</td>
              <td class="text-center b1">{{ $t("trickingCode") }}</td>
              <td class="text-center b1">{{ $t("expence") }}</td>
              <td class="text-center b1">{{ $t("orderStatus") }}</td>
              <td class="text-center b1"></td>
              <td class="text-center b1"></td>
              <td class="b1"></td>
            </tr>
          </thead>
          <tbody v-for="item in cartData" :key="item.row">
            <tr v-if="item.payment_status == 'Done'">
              <td class="text-center">{{ item.persian_date }}</td>
              <td class="text-center">{{ item.tracking_code }}</td>
              <td class="text-center">{{ item.persian_sum }}</td>
              <td class="text-center greenColor">{{ $t("delivered") }}</td>
              <td class="text-center b1"></td>
              <td class="text-center b1"></td>
              <td class="text-center b1 p-2">
                <div
                  :id="item.id"
                  @click="detailes(item.id)"
                  class="chips rounded-pill btn"
                >
                  {{ $t("details") }}
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cartData: [],
    };
  },
  methods: {
    detailes(id) {
      this.$session.set("oldCartid", id);
      this.$router.push(this.$route.query.to || "/orderDetails/" + id);
    },
  },
  mounted() {
    this.axios.defaults.headers.common["Authorization"] =
      "Bearer " + this.$session.get("token");
    this.axios.get("cart").then((response) => {
      console.log(response.data[0]);
      this.cartData = response.data[0];
    });
  },
};
</script>
<style scoped>
.greenColor {
  color: #20db9d;
}
.redColor {
  color: #ff2727;
}
.yellowColor {
  color: #ffd500;
}
.orangeColor {
  color: #20db6b;
}
.redCirc {
  background-color: #ff2727;
  width: 20px;
  height: 20px;
  border-radius: 100%;
}
.yellowCirc {
  background-color: #ffd500;
  width: 20px;
  height: 20px;
  border-radius: 100%;
}
.orangeCirc {
  background-color: #20db6b;
  width: 20px;
  height: 20px;
  border-radius: 100%;
}
.greenCirc {
  background-color: #2a9d8f;
  width: 20px;
  height: 20px;
  border-radius: 100%;
}
.chips {
  background-color: #d2d2d2;
  color: #3c56c8;
  width: 174px;
  height: 40px;
}
</style>
